import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  input,
  inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ProductSelectItem } from 'src/app/models/product';

@Component({
  selector: 'app-product-direct-select',
  templateUrl: './product-direct-select.component.html',
  styleUrls: ['./product-direct-select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductDirectSelectComponent),
      multi: true,
    },
  ],
})
export class ProductDirectSelectComponent implements ControlValueAccessor {
  private readonly cdr = inject(ChangeDetectorRef);

  readonly products = input<ProductSelectItem[]>([]);
  readonly showDescription = input(true);
  readonly bindLabel = input<string>('name_comercial');

  value: ProductSelectItem | null = null;
  disabled = false;
  private onChange: (value: ProductSelectItem | null) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: ProductSelectItem | null): void {
    this.value = value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (value: ProductSelectItem | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelect(product: ProductSelectItem | null): void {
    this.value = product;
    this.onChange(product);
    this.onTouched();
    this.cdr.markForCheck();
  }

  getLabel(item: ProductSelectItem | null | undefined): string {
    if (!item) {
      return '';
    }
    const bindKey = this.bindLabel();
    const boundValue = bindKey ? (item as unknown as Record<string, unknown>)[bindKey] : '';
    if (typeof boundValue === 'string' && boundValue.trim()) {
      return boundValue.trim();
    }
    return item.display_label ?? item.producto ?? item.name_comercial ?? '';
  }
}
